export const getMode = (MODCAB: number) => {
  switch (MODCAB) {
    case 3:
      return "< ? >";
    case 2:
      return "< ?";
    case 1:
      return "? >";
    default:
      return "= ?";
  }
};

export const getType = (CODCAB: string, base: string) =>
  [
    `AGE${base}`,
    `REC${base}`,
    `CRE${base}`,
    `ABR${base}`,
    `USU${base}`,
    "BULART",
  ].includes(CODCAB)
    ? "number"
    : "text";

export const activeOptions = [
  { value: "", label: "p.all" },
  { value: "1", label: "p.active" },
  { value: "0", label: "p.inactive" },
];

export const sexesOptions = [
  { value: "2", label: "p.male" },
  { value: "1", label: "p.female" },
];

export const itemTypeOptions = [
  { value: "0", label: "p.item" },
  { value: "2", label: "p.serializedItem" },
  { value: "3", label: "p.itemInBulk" },
  { value: "4", label: "p.itemByDate" },
  { value: "1", label: "p.service" },
  { value: "5", label: "p.serviceAndGuarantee" },
  { value: "6", label: "p.internalUse" },
];

export const invTypeOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.manual" },
  { value: "2", label: "p.semiautomatic" },
  { value: "3", label: "p.automatic" },
];

export const editOwnAllOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.editOwn" },
  { value: "2", label: "p.editAll" },
];

export const onlyEditOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.edit" },
];

export const seePrintSaveOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.print" },
  { value: "3", label: "p.printSave" },
];

export const editOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.onlyEdit" },
  { value: "3", label: "p.edit" },
];

export const editDeleteOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.onlyEdit" },
  { value: "3", label: "p.editAndDelete" },
];

export const warnAllowOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.warn" },
  { value: "2", label: "p.allow" },
];

export const salesReportOptions = [
  { value: "0", label: "p.free" },
  { value: "1", label: "p.saveAndManual" },
  { value: "2", label: "p.saveAndAutomatic" },
];

export const editVoidOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.onlyEdit" },
  { value: "3", label: "p.editAndVoid" },
];

export const editAllOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlyOwn" },
  { value: "2", label: "p.editAll" },
  { value: "3", label: "p.onlyDiagnoses" },
  { value: "4", label: "p.onlyItems" },
  { value: "5", label: "p.onlyOwnDiagnoses" },
];

export const infoOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.all" },
  { value: "2", label: "p.onlyOwn" },
];

export const infoCommOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.onlySee" },
  { value: "2", label: "p.onlyOwn" },
  { value: "3", label: "p.editAll" },
];

export const selectUsersOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.edit" },
  { value: "2", label: "p.editAndPassword" },
];

export const selectModifyOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.select" },
  { value: "2", label: "p.selectAndModify" },
  { value: "3", label: "p.onlyModify" },
];

export const customerOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.create" },
  { value: "2", label: "p.createNotUsual" },
];

export const filesOptions = [
  { value: "0", label: "p.blocked" },
  { value: "1", label: "p.see" },
  { value: "2", label: "p.edit" },
];

export const newCodesOptions = ["PRON", "CLIN", "ARTN"];
export const cashCodesOptions = ["PROV", "CLIV", "ARTV"];
export const printCodesOptions = ["PROP", "CLIP", "ARTP"];
export const filesCodesOptions = ["PROD", "CLID", "ARTD"];

export const rolPricesLabels = {
  US1: { label: "p.changePrice", input: "checkbox" },
  DES: { label: "p.activateDiscount", input: "checkbox" },
  IMP: { label: "p.changeTax", input: "checkbox" },
  COM: { label: "p.changeCommission", input: "files" },
  DOC: { label: "p.files", input: "files" },
};

export const statusOptions = [
  { value: "", label: "p.all" },
  { value: "0,1", label: "p.active" },
  { value: "0", label: "p.closed" },
  { value: "1", label: "p.opened" },
  { value: "2", label: "p.canceled" },
];

export const statusPayment = [
  { value: "", label: "p.all" },
  { value: "0", label: "p.pending" },
  { value: "1", label: "p.partial" },
  { value: "0,1", label: "p.noComplete" },
  { value: "2", label: "p.complete" },
];

export const statusComm = [
  { value: "", label: "p.all" },
  { value: "0", label: "p.pending2" },
  { value: "1", label: "p.approved2" },
  { value: "2", label: "p.created2" },
];

export const adminAreas = [
  { value: "ARE", label: "p.departments" },
  { value: "HOR", label: "p.schedules" },
];

export const servicesAreas = [
  { value: "TAL", label: "c.TAL" },
  { value: "PAG", label: "c.PAG2" },
  { value: "FOR", label: "c.FOR" },
  { value: "SDA", label: "c.SDA" },
];

export const accountingAreas = [
  { value: "CTPA", label: "c.CTPA" },
  { value: "VTPA", label: "c.VTPA" },
  { value: "TAR", label: "c.TAR" },
  { value: "CUE", label: "c.CUE" },
  { value: "GAS", label: "c.GAS" },
];

export const branchAreas = [
  { value: "SUC", label: "c.SUC" },
  // { value: "VTPA", label: "c.VTPA" },
  // { value: "TAR", label: "c.TAR" },
];

export const monthsCodes = [
  "p.january",
  "p.february",
  "p.march",
  "p.april",
  "p.may",
  "p.june",
  "p.july",
  "p.august",
  "p.september",
  "p.october",
  "p.november",
  "p.december",
];

export const monthsOptions = [
  { value: "", label: "" },
  { value: "1", label: "p.january" },
  { value: "2", label: "p.february" },
  { value: "3", label: "p.march" },
  { value: "4", label: "p.april" },
  { value: "5", label: "p.may" },
  { value: "6", label: "p.june" },
  { value: "7", label: "p.july" },
  { value: "8", label: "p.august" },
  { value: "9", label: "p.september" },
  { value: "10", label: "p.october" },
  { value: "11", label: "p.november" },
  { value: "12", label: "p.december" },
];

export const headersOptions = [
  { value: "ART", label: "c.ART" },
  { value: "PRO", label: "c.PRO" },
  { value: "CLI", label: "c.CLI" },
  { value: "PED", label: "c.PED" },
  { value: "ENT", label: "c.ENT" },
  { value: "CFA", label: "c.CFA" },
  { value: "REG", label: "c.REG" },
  { value: "SAL", label: "c.SAL" },
  { value: "TRA", label: "c.TRA2" },
  // { value: "TRA2", label: "c.TRA2" },
  { value: "COT", label: "c.COT" },
  { value: "ORD", label: "c.ORD" },
  { value: "PRE", label: "c.PREP" },
  { value: "FAC", label: "c.FAC" },
  { value: "DEV", label: "c.DEV" },
  { value: "ALC", label: "c.ALC" },
  { value: "SEV", label: "c.SEV" },
  { value: "CAJ", label: "c.CAJ" },
  { value: "COB", label: "c.COB" },
  { value: "ICA", label: "c.ICA" },
  { value: "ICO", label: "c.ICO" },
  { value: "IENV", label: "c.IENV" },
  { value: "IRE", label: "c.IRE" },
  { value: "PL0", label: "c.PL0" },
  { value: "PLA", label: "c.PLA" },
];

export const languageOptions = [
  { value: "general", label: "p.general" },
  { value: "purchasesMenu", label: "p.purchasesMenu" },
  { value: "purchases", label: "p.purchases" },
  { value: "salesMenu", label: "p.salesMenu" },
  { value: "sales", label: "p.sales" },
  { value: "servicesMenu", label: "p.servicesMenu" },
  { value: "warehouse", label: "p.warehouse" },
  { value: "admin", label: "p.admin" },
  { value: "settings", label: "p.settings" },
  { value: "document", label: "p.document" },
  { value: "lists", label: "p.lists" },
];

export const stationeryOptions = [
  { value: "PED", label: "c.PED" },
  { value: "ENT", label: "c.ENT" },
  { value: "CFA", label: "c.CFA2" },
  { value: "DEV", label: "c.DEV2" },
  { value: "SAL", label: "c.SALP" },
  { value: "TRA", label: "c.TRA" },
  { value: "COT", label: "c.COT" },
  { value: "ORD", label: "c.ORD" },
  { value: "PRE", label: "c.PREP" },
  { value: "FAC", label: "c.FAC2" },
  { value: "REG", label: "c.REG2" },
  { value: "SEV", label: "c.SEV" },
  { value: "ART", label: "c.ART" },
];

export const generalOptions = [
  { value: "PAI", label: "c.PAI" },
  { value: "BCK", label: "c.BCK" },
];

export const webOptions = [
  { value: "ART", label: "c.ART" },
  { value: "COD", label: "p.codes" },
  { value: "COL", label: "p.colors" },
  { value: "ESP", label: "c.F6" },
  { value: "MAR", label: "c.F3" },
  { value: "INV", label: "c.STO" },
  { value: "BLO", label: "c.BLO" },
  { value: "CAT", label: "c.F1" },
  { value: "CLI", label: "c.CLI" },
  { value: "USU", label: "c.USU" },
  { value: "ORD", label: "c.B2" },
  { value: "PRE", label: "c.B4" },
  { value: "FAC", label: "c.B5" },
  { value: "SEV", label: "c.C1" },
  { value: "SET", label: "p.synchronizationList" },
];
